module.exports = __webpack_public_path__ + "img/companie-premium.d5a54af5.png";